import {memo} from 'react';

import type {SVGProps} from 'react';

export const TermsAndConditionsIllustration = memo(function TermsAndConditionsIllustration(
  props: SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M41.1673 17H25.8333C23.7163 17 22.0003 18.716 22.0003 20.833V42.166C22.0003 44.284 23.7163 46 25.8333 46H41.1663C43.2843 46 45.0003 44.284 45.0003 42.167V20.833C45.0003 18.716 43.2843 17 41.1673 17Z"
        fill="#8CE7F2"
      />
      <path
        d="M30.4997 12.17V9.5"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.4997 9.5C30.4997 7.291 28.7087 5.5 26.4997 5.5H10.4997C8.29069 5.5 6.49969 7.291 6.49969 9.5V31.5C6.49969 33.709 8.29069 35.5 10.4997 35.5H11.9997"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 14.5H13.5"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 20.5H13.5"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 26.5H13.5"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.9566 42.5H37.4996C39.7086 42.5 41.4996 40.709 41.4996 38.5V23.723"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.5003 18.872V16.5C41.5003 14.291 39.7093 12.5 37.5003 12.5H21.5003C19.2913 12.5 17.5003 14.291 17.5003 16.5V38.5C17.5003 40.709 19.2913 42.5 21.5003 42.5H22.9573"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4997 21.5H24.4997"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4997 27.5H24.4997"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4997 33.5H24.4997"
        stroke="#18193F"
        strokeWidth={3}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
